// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
// Describes the navigation hierarchy of the reports section. Drives the
// hover dropdown attached to the "Reports" crumb in ReportBreadcrumbs so
// the breadcrumb trail doubles as a quick-jump nav within the section.
import { BreadcrumbNavSection } from '@/components/section-breadcrumbs';

// Sections that live beneath the reports hub at /reports, mirroring the
// navigable report families shown on the reports landing page. The dropdown
// renders an `Asset reports` header above the logistics surfaces and a
// `Project reports` header above the commercial surfaces so users can scan
// the menu by intent.
const REPORT_NAV_SECTIONS: BreadcrumbNavSection[] = [
  {
    heading: 'Asset reports',
    items: [
      { label: 'Inventory asset report', to: '/reports/inventory' },
      { label: 'Transit asset report', to: '/reports/transit' },
      { label: 'Field asset report', to: '/reports/field' },
      { label: 'Fulfillment report', to: '/reports/fulfillment' },
    ],
  },
  {
    heading: 'Project reports',
    items: [
      { label: 'Active projects report', to: '/reports/active-projects' },
      { label: 'Upcoming projects report', to: '/reports/upcoming-projects' },
      { label: 'Past projects report', to: '/reports/past-projects' },
      {
        label: 'Upcoming project starts report',
        to: '/reports/upcoming-project-starts',
      },
      {
        label: 'Upcoming project completions report',
        to: '/reports/upcoming-project-completions',
      },
    ],
  },
];

// Returns the section list for a report breadcrumb label, or undefined when
// the label heads no nested options (e.g. the accounting hub, whose report
// surfaces live under their own section).
export function findReportNavChildren(
  label: string
): BreadcrumbNavSection[] | undefined {
  if (label === 'Reports') {
    return REPORT_NAV_SECTIONS;
  }
  return undefined;
}
